import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { importCSS } from '../../lib/ep.js';

import { SquaredButton } from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';

const SingleBanner = ({ banner, ...props }) => {
	const type = (banner.type) ? banner.type : false;

	let description = banner.description;

	if(type == 'html') {
		return (
			<li class="is_banner">
				{(banner.title) && (
					<h3 class="area_title">{banner.title}</h3>
				)}

				<div class="banner_content" dangerouslySetInnerHTML={{ __html:description}} />
			</li>
		)
	}
	
	if(type == 'links') {
		description = description.replace(/\r/g, " ");
		description = description.replace(/\n\n/g, "\n");
		description = description.replace(/\n/g, "</li><li>");

		return (
			<li class="is_banner">
				{(banner.title) && (
					<h3 class="area_title">{banner.title}</h3>
				)}

				<div class="banner_content" dangerouslySetInnerHTML={{ __html:`<ul><li>${description}</li></ul>`}} />
			</li>
		)
	}
	
	if(type == 'banner') {
		const event = (banner.gaevent) ? { platform:'panel', category:'admin', action:'link', value:banner.gaevent } : null;

		return (
			<li class="is_banner">
				{(banner.title) && (
					<h3 class="area_title">{banner.title}</h3>
				)}

				<ActionLink _href={banner.link} _target={banner.target_flg ? '_blank' : null} _gaEvent={event}>
					{(banner.full_image != undefined) && (
						<img src={banner.full_image} width="100%" alt={banner.title} />
					)}
					{(description != '') && (
						<span class="banner_content" dangerouslySetInnerHTML={{ __html:description}}></span>
					)}
				</ActionLink>
			</li>
		)
	}

	return null;
};

class SweepSidebarBanners extends Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			banner_visible:0,
			slide_enabled:true,
		}

		this.banners = [];
		$.each(props.banners, (i, item) => {
			this.banners.push(item);
		});

		this.interval;
	}

	componentWillMount() {
		importCSS('comp/sweeps.css');
	}

	componentDidMount() {
		this.startAutoNavigate();

		if(this.banners.length > 0) {
			const _container = document.querySelector('.profile_grid');
			_container.classList.remove('without_menu');
			_container.classList.add('with_sidebar');
		}
	}

	navigateToBanner(banner_index) {
		this.setState({ banner_visible:banner_index });
	}

	startAutoNavigate() {
		this.interval = setInterval(() => {
			var next_banner = (this.state.banner_visible < this.banners.length - 1) ? this.state.banner_visible + 1 : 0;
			this.navigateToBanner(next_banner);
		}, 10000);
	}

	stopAutoNavigate() {
		clearInterval(this.interval);
	}

	render() {
		if(this.banners.length === 0) return null;

		return (
			<div class="gui_sidebar_container gui_is_static gui_only_as_sidebar gui_pos_rel" onMouseEnter={() => this.stopAutoNavigate()} onMouseLeave={() => this.startAutoNavigate()}>
				<aside class="gui_sidebar_cart main_bg gui_banners_sidebar" style={{paddingBottom:(this.banners.length > 1) ? '30px' : '0'}}>
					<ul class="gui_pos_rel" style={{left:`-${this.state.banner_visible * 100}%`}}>
						{this.banners.map((banner, i) => {
							return (
								<SingleBanner key={`banner_${i}`} banner={banner} />
							)
						})}
					</ul>
				</aside>

				{(this.banners.length > 1) && (
					<nav class="gui_banner_nav">
						<ul>
							{this.banners.map((banner, i) => {
								const icon = (this.state.banner_visible == i) ? 'ep-circle' : 'ep-circle-empty';

								return (
									<li key={i}>
										<SquaredButton
											color="mainText"
											icon={icon}
											_class={{other:'nav_btn not_bordered_button'}}
											onClick={() => this.navigateToBanner(i)}
											aria-label="View banner details"
										/>
									</li>
								)
							})}
						</ul>
					</nav>
				)}
			</div>
		)
	}
}

export default injectIntl(SweepSidebarBanners);